// src/components/SignIn.js
import React, { useState, useContext } from 'react';
import { loginUser } from '../api';
import { AuthContext } from '../Context/AuthContext';

const SignIn = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const { login } = useContext(AuthContext); // Access login function from context

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await loginUser({ email, password });
            login(response.data.access_token); // Save token using context
            // window.location.reload(); // Remove this line
        } catch (error) {
            alert(error.response?.data?.message || 'Login failed');
        }
    };

    return (
        <div className="flex flex-col gap-4 w-full max-w-md mx-auto items-center bg-[#1c1c24]">
            <form onSubmit={handleSubmit} className="bg-[#1c1c24] p-8 rounded-lg shadow-md w-full max-w-md">
                <h2 className="text-2xl font-bold mb-4 text-center text-white">Sign In</h2>
                <div className="mb-4">
                    <label htmlFor="email" className="block text-sm font-medium text-gray-400">
                        Email
                    </label>
                    <input
                        type="email"
                        id="email"
                        placeholder="Enter your email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        className="mt-1 block w-full px-3 py-2 border border-gray-700 rounded-md bg-[#2a2a33] text-white focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                        required
                    />
                </div>
                <div className="mb-4">
                    <label htmlFor="password" className="block text-sm font-medium text-gray-400">
                        Password
                    </label>
                    <input
                        type="password"
                        id="password"
                        placeholder="Enter your password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        className="mt-1 block w-full px-3 py-2 border border-gray-700 rounded-md bg-[#2a2a33] text-white focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                        required
                    />
                </div>
                <button
                    type="submit"
                    className="w-full bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                >
                    Login
                </button>
            </form>
            <p className="my-4 text-gray-400">
                Don't have an account?{' '}
                <a href="/signup" className="text-blue-500 hover:underline">
                    Sign Up
                </a>
            </p>
        </div>
    );
};

export default SignIn;